export const GOT_IP_ACTION = {
    name: 'GOT_IP_ACTION',
    action: ip => ({
        ip,
        type: GOT_IP_ACTION.name
    })
};

export const GOT_GEOLOCATION_SUCCESS_ACTION = {
    name: 'GOT_GEOLOCATION_SUCCESS_ACTION',
    action: coords => ({
        coords,
        type: GOT_GEOLOCATION_SUCCESS_ACTION.name
    })
};